import styled from "styled-components";

export default styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 170px;

  .credit-cont  {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid var(--base-gray-30);
    justify-content: center;

    &:last-of-type {
      border-bottom: 0px; 
    }
  }

  .credit-row {
    display: flex;

    .icon-cont {
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .text-cont {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h5 {
        color: var(--base-gray-70);
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 0px;
      }

      p {
        font-weight: 500;
        margin-bottom: 0px;
      }
    }
  }
`;
